// extracted by mini-css-extract-plugin
module.exports = {"StudiesModuleSubjectForm":"style_StudiesModuleSubjectForm__1SoqK","titleWrapper":"style_titleWrapper__165YZ","contentWrapper":"style_contentWrapper__62Hl9"};